/**
 * StatisticDaily
 * --
 */
import React from 'react';
import { Descriptions, Table } from 'antd';
import { Content, Title, Row, Col, Statistic, TabMenu } from 'components';
import moment from 'moment';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import * as XLSX from 'xlsx/xlsx.mjs';

/* 
사용중인 필드
  date: 날짜
  totalAmount: Total(합계금액+환불금액+할인금액)
  completedTotalAmount: 합계금액(결제완료건)
  netSales: 순매출(합계금액 - 할인금액)
  paymentsCount: 결제건수(결제완료건)
  discountAmount: 할인금액
  couponAppliedCount: 쿠폰적용 주문수
  refundAmount: 환불금액
  refundCount: 환불건수
  totalAmountKIOSK: KIOSK합계금액
  paymentsCountKIOSK: KIOSK결제건수
  totalAmountAPP: APP합계금액
  paymentsCountAPP: APP결제건수
  totalAmountPOS: POS합계금액
  paymentsCountPOS: POS결제건수
*/

/**----------------------------------------
 * [Component] 일자별 매출
 * ----------------------------------------
 */
const StatisticDaily = ({
  // shopList, // 업체목록
  // currentShop, // 선택된 업체 키
  data, // 차트 데이터
  startDate,
  endDate,
  onSelect,
  dateRange,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // const currentShopInfo = shopList.filter(({ key }) => key === currentShop)[0];
  /* ===== FUNCTION ===== */
  const handleCalculate = (d, key) => {
    return d.reduce((acc, cur) => acc + Number(cur[key]), 0);
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */

  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Row>
          {/* === 상단 > 타이틀 === */}
          <Col x={12}>
            <Title style={{ marginBottom: 7.5 }}>일자별 리포트</Title>
          </Col>
          <Col x={12} style={{ textAlign: 'right' }}>
            <Title
              level={5}
              align="right"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 7.5,
              }}
            >
              <small>조회기간:</small>&nbsp;&nbsp;
              {!dateRange.startDate || !dateRange.endDate ? (
                <>
                  {moment(startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(endDate).format('YYYY.MM.DD(ddd)')}
                </>
              ) : (
                <>
                  {moment(dateRange.startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(dateRange.endDate).format('YYYY.MM.DD(ddd)')}
                </>
              )}
            </Title>
          </Col>
        </Row>
        <div style={{ overflowX: 'auto', background: '#fff' }}>
          {data && (
            <Descriptions
              className="boxShadow"
              size="small"
              layout="vertical"
              column={15}
              bordered
              style={{ width: 1710 }}
              contentStyle={{ textAlign: 'right' }}
              items={[
                {
                  key: 'date',
                  label: '',
                  style: { width: 118 },
                  contentStyle: { textAlign: 'center' },
                  children: <p>합계</p>,
                },
                {
                  key: 'totalAmount',
                  label: 'Total',
                  style: { width: 163 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'totalAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'completedTotalAmount',
                  label: '합계금액',
                  style: { width: 118 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'completedTotalAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'netSales',
                  label: '순매출',
                  style: { width: 118 },
                  children: (
                    <p>
                      {stringToMoneyFormat(handleCalculate(data, 'netSales'))}
                    </p>
                  ),
                },
                {
                  key: 'paymentsCount',
                  label: '결제건수',
                  style: { width: 98 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'paymentsCount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'discountAmount',
                  label: '할인금액',
                  style: { width: 98 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'discountAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'couponAppliedCount',
                  label: '쿠폰적용 주문수',
                  style: { width: 123 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'couponAppliedCount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'refundAmount',
                  label: '환불금액',
                  style: { width: 108 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'refundAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'refundCount',
                  label: '환불건수',
                  style: { width: 88 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'refundCount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'totalAmountKIOSK',
                  label: 'KIOSK합계금액',
                  style: { width: 108 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'totalAmountKIOSK')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'paymentsCountKIOSK',
                  label: 'KIOSK결제건수',
                  style: { width: 108 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'paymentsCountKIOSK')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'totalAmountAPP',
                  label: 'APP합계금액',
                  style: { width: 108 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'totalAmountAPP')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'paymentsCountAPP',
                  label: 'APP결제건수',
                  style: { width: 108 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'paymentsCountAPP')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'totalAmountPOS',
                  label: 'POS합계금액',
                  style: { width: 108 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'totalAmountPOS')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'paymentsCountPOS',
                  label: 'POS결제건수',
                  style: { width: 108 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'paymentsCountPOS')
                      )}
                    </p>
                  ),
                },
              ]}
            />
          )}
        </div>
        <br />

        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            className="boxShadow"
            bordered
            size="small"
            dataSource={data ?? []}
            scroll={{
              x: 'max-content',
            }}
            style={{ minHeight: 580 }}
            onRow={(record) => {
              return {
                onClick: () => onSelect(record), // 행 클릭 시 이벤트 처리
              };
            }}
            columns={[
              {
                title: '날짜',
                dataIndex: 'date',
                width: 120,
                fixed: 'left',
                render: (v) => moment(v).format('YYYY-MM-DD(ddd)'),
              },
              {
                title: (
                  <span style={{ lineHeight: 0.5 }}>
                    Total
                    <br />
                    <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                      (합계금액+환불금액+할인금액)
                    </span>
                  </span>
                ),
                dataIndex: 'totalAmount',
                width: 165,
                // align: 'center',
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <span style={{ lineHeight: 0.5 }}>
                    합계금액
                    <br />
                    <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                      (결제완료건)
                    </span>
                  </span>
                ),
                dataIndex: 'completedTotalAmount',
                width: 120,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <span style={{ lineHeight: 0.5 }}>
                    순매출
                    <br />
                    <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                      (합계금액 - 할인금액)
                    </span>
                  </span>
                ),
                dataIndex: 'netSales',
                width: 120,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <span style={{ lineHeight: 0.5 }}>
                    결제건수
                    <br />
                    <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                      (결제완료건)
                    </span>
                  </span>
                ),
                dataIndex: 'paymentsCount',
                width: 100,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: '할인금액',
                dataIndex: 'discountAmount',
                width: 100,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: '쿠폰적용 주문수',
                dataIndex: 'couponAppliedCount',
                width: 125,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: '환불금액',
                dataIndex: 'refundAmount',
                width: 110,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: '환불건수',
                dataIndex: 'refundCount',
                width: 90,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <>
                    KIOSK
                    <br />
                    합계금액
                  </>
                ),
                dataIndex: 'totalAmountKIOSK',
                width: 110,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <>
                    KIOSK
                    <br />
                    결제건수
                  </>
                ),
                dataIndex: 'paymentsCountKIOSK',
                width: 110,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <>
                    APP
                    <br />
                    합계금액
                  </>
                ),
                dataIndex: 'totalAmountAPP',
                width: 110,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <>
                    APP
                    <br />
                    결제건수
                  </>
                ),
                dataIndex: 'paymentsCountAPP',
                width: 110,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <>
                    POS
                    <br />
                    합계금액
                  </>
                ),
                dataIndex: 'totalAmountPOS',
                width: 110,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
              {
                title: (
                  <>
                    POS
                    <br />
                    결제건수
                  </>
                ),
                dataIndex: 'paymentsCountPOS',
                width: 110,
                render: (v) => (
                  <div style={{ textAlign: 'right' }}>
                    {stringToMoneyFormat(v)}
                  </div>
                ),
              },
            ]}
          />
        </div>
      </Content>
    </>
  );
};

StatisticDaily.defaultProps = {
  onSelect: () => {},
};
export default StatisticDaily;
